import useTitle from '@/hooks/useTitle.ts';
import {H2} from '@blueprintjs/core';
import {ReactElement, ReactNode} from 'react';

interface Props {
	title: string,
	children?: ReactNode,
}

export default function Title({title, children}: Props): ReactElement {
	useTitle(title);

	return (
		<div style={{display: 'flex', gap: 10}}>
			<H2>{title}</H2>
			{children}
		</div>
	);
}
